import { ActionType, ActionTypes, State } from './types';

const initialState = {
  ready: false,
  mustUpdate: false,
  appVisibility: null,
  mustUpdatePoints: false,
  mustUpdateSummary: false,
};

const appReducer = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.RESET_APP:
      return initialState;
    case ActionTypes.SET_READY:
      return {
        ...state,
        ready: action.payload,
      };
    case ActionTypes.SET_MUST_UPDATE:
      return {
        ...state,
        mustUpdate: action.payload,
      };
    case ActionTypes.SET_APP_VISIBILITY:
      return {
        ...state,
        appVisibility: action.payload,
      };
    case ActionTypes.MUST_UPDATE_POINTS:
      return {
        ...state,
        mustUpdatePoints: action.payload,
      };
    case ActionTypes.MUST_UPDATE_SUMMARY:
      return {
        ...state,
        mustUpdateSummary: action.payload,
      };
    default:
      return state;
  }
};

export default appReducer;
